import { Component, ElementRef, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppConfig } from 'src/app/config/app-config';
import { AppConfigService } from 'src/app/config/app-config.service';
import { DawaAddress } from 'src/app/profil/components/profil-address-input/profil-address-input.component';
import { Focusable } from '../../services/autofocus/focusable';

declare const adressevaelger: {
  adressevaelger: (
    inputElement: HTMLElement,
    options: {
      select: (selected: DawaAddress) => void;
      maksimum: number;
      medtagForeloebige: boolean;
      token: string;
    }
  ) => unknown;
};

@Component({
  selector: 'bom-dawa-adresse-form-input',
  templateUrl: './dawa-adresse-form-input.component.html',
  styleUrls: ['./dawa-adresse-form-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DawaAdresseFormInputComponent),
      multi: true,
    },
  ],
})
export class DawaAdresseFormInputComponent implements OnInit, ControlValueAccessor, Focusable {
  constructor(appConfigService: AppConfigService) {
    this.appConfig = appConfigService.getConfig();
  }
  value: string = undefined;

  @Input()
  form: FormGroup;

  @Input()
  id: string;

  @Input()
  formControlName: string;

  @Input()
  isDisabled: boolean;

  @Input()
  isRequired: boolean;

  @Input()
  placeholder: string;

  @ViewChild('input', { static: true })
  input: ElementRef;

  private appConfig: AppConfig;

  ngOnInit() {
    // Call disable() if isDisabled is true
    if (this.isDisabled) {
      this.form.controls[this.formControlName].disable();
    }

    const input = this.input.nativeElement as HTMLInputElement;
    const control = this.form.controls[this.formControlName];

    adressevaelger.adressevaelger(input, {
      select: (selected: DawaAddress) => {
        control.setValue(selected.adresse.adressebetegnelse);
      },
      maksimum: 20,
      medtagForeloebige: true,
      token: this.appConfig.adressevaelgerToken,
    });

    // Drill-down suggestions set input.value directly (no `select`, no 'input' event),
    // so commit it ourselves on the bubbled click/keyup.
    const commitPickedSuggestion = (event: Event) => {
      if (!(event.target as HTMLElement).closest('.adressevaelger-suggestion')) {
        return;
      }
      if (input.value && input.value !== control.value) {
        control.setValue(input.value);
      }
    };
    input.parentElement?.addEventListener('click', commitPickedSuggestion);
    input.parentElement?.addEventListener('keyup', commitPickedSuggestion);
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onBlur() {
    this.form.controls[this.formControlName].markAsDirty();
  }

  setFocus() {
    this.input.nativeElement.focus({ preventScroll: true });
  }
}
